import { Container, Grid } from '@mui/material'
import { useLocation, useParams } from 'react-router'
import ButtonBack from '../../../../shared/components/buttons/ButtonBack'
import VerifyAccessRoute from '../../../../shared/components/routes/VerifyAccessRoute'
import NotFound from '../../../../shared/pages/NotFound'
import CoursesModal from '../components/CoursesModal'
import CourseContent from '../components/detail/CourseContent'
import CourseDetailSidebar from '../components/detail/CourseDetailSidebar'
import CoursesDetailNotifications from '../components/detail/CoursesDetailNotifications'
import LessonContent from '../components/detail/LessonContent'
import { useCourseDetail } from '../hooks/useCourseDetail'

function CourseDetail() {
  const location = useLocation()
  const { brandId, slug } = useParams<{ brandId: string; slug: string }>()

  const {
    course,
    lesson,
    authUser,
    showForm,
    showLessonForm,
    favoriteState,
    handleChangeLesson,
    handleFavoriteClick,
    setViewLesson,
    infoDetail
  } = useCourseDetail(brandId, slug)

  // Validate if course exists, status is enable and if is admin site
  if (course !== null && course.status === 0 && !(location.pathname.includes('admin') || location.pathname === '/escritorio')) {
    return <NotFound showLogo={false} />
  }

  const isLesson = lesson != null && !showLessonForm

  return (
    <>
      {course != null && (
        <Container maxWidth="lg">
          {showForm && authUser !== null && <CoursesModal />}

          {lesson === null && showLessonForm === false ? (
            <ButtonBack data-coursedetail="goback" dataName="course" />
          ) : (
            <ButtonBack data-lessondetail="goback" goBack={false} customFunction={setViewLesson(null)} dataName="lesson" />
          )}

          <Grid container spacing={5}>
            <Grid item xs={12} md={8} id="course-container">
              <VerifyAccessRoute visibility={course.visibility} />

              {isLesson ? (
                <LessonContent lesson={lesson} course={course} />
              ) : (
                <CourseContent
                  course={course}
                  showLessonForm={showLessonForm}
                  location={location}
                  handleChangeLesson={handleChangeLesson}
                  authUser={authUser}
                />
              )}
            </Grid>

            <Grid item xs={12} md={4}>
              <CourseDetailSidebar
                course={course}
                lesson={lesson}
                isLesson={isLesson}
                favoriteState={favoriteState}
                handleFavoriteClick={handleFavoriteClick}
                infoDetail={infoDetail}
              />
            </Grid>
          </Grid>
        </Container>
      )}
      <CoursesDetailNotifications />
    </>
  )
}

export default CourseDetail
